<template>
  <role-edit></role-edit>
</template>

<script>
import RoleEdit from "../../../components/Settings/RoleEdit";
export default {
  name: "SettingsRoleEditView",
  components: { RoleEdit }
};
</script>

<style scoped></style>
